import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function EmptyStateV2({
  title,
  description,
  icon,
  action,
  className,
}: {
  title: string;
  description?: string;
  icon?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "v2-panel v2-motion-state-fade px-4 py-6 text-center",
        className
      )}
    >
      {icon ? <div className="mb-3 flex justify-center">{icon}</div> : null}
      <h3 className="v2-text-heading text-base font-semibold">{title}</h3>
      {description ? (
        <p className="v2-text-body mt-2 text-sm">{description}</p>
      ) : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}
